export const AdminUsers = () => {
    return (
        <table className="table-auto text-gray-400 w-full text-left border border-gray-400 rounded-sm border-separate">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Location</th>
                    <th>User ID</th>
                </tr>
            </thead>
            <tbody></tbody>
        </table>
    )
}